module.exports = __webpack_public_path__ + "static/media/prowler920-cleaner.b239bcbf.png";